module.exports = __webpack_public_path__ + "static/img/01-zhihuiyecaiyitihuayun.3a90fd08.png";